import { createMemo } from "solid-js";
import { useWebStoreContext } from "~/context/webstore_context";
import {
  BrandExtraMetadata,
  SimulatedTransactionDetails,
  VoucherProduct,
} from "~/server/types/brand";
import { useRnrPayment } from "~/hooks/use_rnr_payment";
import { FAQ } from "~/data/static_faqs/types";

type UseHomepageSingleBrandProps = {
  brandKey: string;
  brand: VoucherProduct | null;
  brandExtraMetadata: BrandExtraMetadata | null;
  simulateTransactionDetails: SimulatedTransactionDetails | null;
  simulateError: string | null;
};

export function useHomepageSingleBrand(props: UseHomepageSingleBrandProps) {
  const {
    brandKey,
    brand,
    brandExtraMetadata,
    simulateTransactionDetails,
    simulateError,
  } = props;

  const { storeState, getClientId, getMode } = useWebStoreContext();

  // Get FAQs
  function getFaqs(): FAQ[] {
    return brandExtraMetadata?.faqs ?? [];
  }

  // Use webstore payment hook
  const webstorePayment = createMemo(() => {
    if (!brand) return null;

    return useRnrPayment({
      brand: () => brand!,
      brandKey: brandKey,
    });
  });

  return {
    brand,
    brandExtraMetadata,
    simulateTransactionDetails,
    simulateError,
    getMode,
    getClientId,
    isLoggedIn: storeState.isLoggedIn,
    coinsBalance: storeState.coins ?? 0,
    userName: storeState.v4HomePage?.user.firstName ?? "",
    getFaqs,
    onClickGetThisCard: webstorePayment()?.onClickGetThisCard,
    ctaState: webstorePayment()?.ctaState,
    setCtaState: webstorePayment()?.setCtaState,
    showFullPageLoadingOverlay: webstorePayment()?.showFullPageLoadingOverlay,
  };
}
